import { Link } from 'react-router-dom';

interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center flex-wrap gap-1.5 text-sm text-foreground-500">
      <Link to="/" className="hover:text-accent-600 transition-colors flex items-center gap-1">
        <i className="ri-home-4-line w-4 h-4 flex items-center justify-center"></i>
        首页
      </Link>
      {items.map((item, idx) => (
        <span key={`${item.label}-${idx}`} className="flex items-center gap-1.5">
          <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center text-foreground-300"></i>
          {item.to ? (
            <Link to={item.to} className="hover:text-accent-600 transition-colors">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-900 font-medium">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}